import { Network } from "@capacitor/network";
import { Capacitor } from "@capacitor/core";

/**
 * A home-screen icon implies the app works offline in a way a browser tab does not. This
 * app does not (yet) — so the least it can do is SAY so instead of showing a spinner that
 * never resolves. That is what the offline banner is for; this is what feeds it.
 */
export type NetworkState = { online: boolean };

export function getNetworkState(): Promise<NetworkState> {
  if (!Capacitor.isNativePlatform()) {
    return Promise.resolve({ online: navigator.onLine });
  }
  return Network.getStatus().then((s) => ({ online: s.connected }));
}

export function onNetworkChange(handler: (state: NetworkState) => void): () => void {
  if (!Capacitor.isNativePlatform()) {
    const on = () => handler({ online: true });
    const off = () => handler({ online: false });
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }
  const sub = Network.addListener("networkStatusChange", (s) => handler({ online: s.connected }));
  return () => void sub.then((h) => h.remove());
}
